<template>
  <div :class="[{opened: isOpened}]">
    <div class="inner">
      <div v-for="(message, i) in messages" :key="i">
        <tutorial-message :message="message"/>
      </div>
    </div>
  </div>
</template>

<script>
import TutorialMessage from './TutorialMessage';

export default {
  name: 'Tutorial',
  components: {
    'tutorial-message': TutorialMessage,
  },
  computed: {
    messages() {
      return this.$store.state.game.tutorials;
    },
    isOpened() {
      return this.$store.state.game.tutorials.length > 0;
    },
  },
};
</script>

<style scoped lang="scss">
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.tutorial {
  color: #fff;
  overflow-y: scroll;
  background: rgba(0, 0, 0, 0.9);
  border-radius: 6px;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
  display: none;
  animation: fadeIn 0.5s;

  &.opened {
    display: block;
  }

  .inner {
    padding: 2em 5em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/Tutorial.vue